export const config = {
  titleShareEmailForm:
    "Let's keep in touch!\nKeep aloop of the news about \nModsen growth to be able to grab the chance of our cooperation.",
  imageShareEmailForm: {
    path: '/images/email-subscription-news.svg',
    width: 288,
    height: 217,
  },
  titleShareEmailFormSubmited: '\nThanks, we’ve got it!',
  imageShareEmailFormSubmited: {
    path: '/images/keep-in-touch-submited.webp',
    width: 288,
    height: 222,
  },
}
